module.exports = __webpack_public_path__ + "img/icon1.3b609441.png";